import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";

import AssistantText from "src/reusable/Chat/AssistantMessage/AssistantText";
import AssistantTextContainer from "src/reusable/Chat/AssistantMessage/AssistantTextContainer";
import { useChatStore } from "../stores/ChatStore";
import AssistantAvatar from "./ui/AssistantAvatar";

const InitialChatPrompt = () => {
  const { config: chatConfig } = useChatStore();

  const theme = useTheme();
  const lessThanMdBreakpoint = useMediaQuery(theme.breakpoints.down("md"));

  if (chatConfig?.initialPrompt) {
    return (
      <Box
        id={`chat-bubble-container-${-1}`}
        className={`chat-bubble-container Assistant`}
      >
        <Stack
          direction={lessThanMdBreakpoint ? "column" : "row"}
          gap={2}
          alignItems="flex-start"
        >
          <AssistantAvatar />
          <Box id={`inital-prompt`} className="chat-bubble-content">
            <AssistantTextContainer messageIndex={-1}>
              <Box>
                <div className="chat-bubble">
                  <AssistantText chatMessage={chatConfig?.initialPrompt} />
                </div>
              </Box>
            </AssistantTextContainer>
          </Box>
        </Stack>
      </Box>
    );
  }
};

export default InitialChatPrompt;
